import { render, staticRenderFns } from "./court_list.vue?vue&type=template&id=3d24e5a7"
import script from "./court_list.vue?vue&type=script&lang=js"
export * from "./court_list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports